import React from 'react';
import { CONTEXT_STRIP_LABELS } from './feedbackCopy';
import { displayContextShape } from './feedbackPropTypes';
const FeedbackContextStrip = ({
  context
}) => {
  const rows = [{
    key: 'page',
    label: CONTEXT_STRIP_LABELS.page,
    value: context.route || context.url
  }, {
    key: 'browser',
    label: CONTEXT_STRIP_LABELS.browser,
    value: context.browser
  }, {
    key: 'timestamp',
    label: CONTEXT_STRIP_LABELS.timestamp,
    value: context.timestamp
  }].filter(({
    value
  }) => Boolean(value));
  return /*#__PURE__*/React.createElement("dl", {
    className: "t-feedback-context"
  }, rows.map(({
    key,
    label,
    value
  }) => /*#__PURE__*/React.createElement("div", {
    key: key,
    className: "t-feedback-context__row"
  }, /*#__PURE__*/React.createElement("dt", {
    className: "t-feedback-context__label"
  }, label), /*#__PURE__*/React.createElement("dd", {
    className: "t-feedback-context__value"
  }, value))));
};
FeedbackContextStrip.propTypes = {
  context: displayContextShape.isRequired
};
export default FeedbackContextStrip;